
const navItems = [
    { label: "Home", href: "#hero" },
    { label: "About", href: "#about" },
    { label: "Portfolio", href: "#portfolio" },
    { label: "Skills", href: "#skills" },
    { label: "Service", href: "#services" },
    { label: "Blog", href: "#blog" },
    { label: "Contact", href: "#contact" },
];

export default function NavLinks() {

    return (
        <div
            className="hidden md:flex gap-6"
            data-aos="fade-up"
            data-aos-duration="1000"
        >
            {navItems.map((item) => (
                <a
                    key={item.href}
                    href={item.href}
                    className="text-black dark:text-white text-sm font-medium hover:text-primary duration-150"
                >
                    {item.label}
                </a>
            ))}
        </div>
    );
}